import { SiteContext } from '../../../common';
import { SiteSettingsScope } from '../../enums';
import { siteSettingsHttp } from '../site-settings-api';

export const getSiteSettings = async <T>(
  locale: string,
  scope: SiteSettingsScope | SiteSettingsScope[],
  siteContext: SiteContext
): Promise<T> => {
  const scopes = Array.isArray(scope) ? scope.join(',') : scope;
  const url = `/settings?site=${siteContext}&marketLocale=${locale}&scope=${scopes}`;
  const response = await siteSettingsHttp.get<T>(url);
  return response.data;
};
